// Central configuration for FaMa Apartments landing page.
// Placeholders below are meant to be edited easily by the owner.

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Primary WhatsApp number (new contacts) — Italy (+39)
export const WHATSAPP_NUMBER = "393515688765";
export const WHATSAPP_DISPLAY = "+39 351 5688765";
export const WHATSAPP_SECONDARY_DISPLAY = "+39 342 6956065";

export const WHATSAPP_DEFAULT_MESSAGE =
    "Ciao FaMa Apartments! Vorrei ricevere informazioni sulla gestione del mio immobile.";

export const whatsappLink = (message = WHATSAPP_DEFAULT_MESSAGE) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

// Editable contacts (footer)
export const CONTACTS = {
    email: "info@famaapartments.it",
    whatsappPrimary: WHATSAPP_DISPLAY, // Matteo (nuovi contatti)
    whatsappSecondary: WHATSAPP_SECONDARY_DISPLAY, // Fabrizio
};

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_a6d36fd9-129a-4aff-af67-c9bda1bd6de6/artifacts/46u4cizc_FAMA-04.webp";

// Real FaMa Apartments photography (swap URLs anytime to change photos).
export const IMAGES = {
    hero: "https://customer-assets-jai6qajn.emergentagent.net/job_fama-roma-pm/artifacts/mrqvr8b7_viamecenate59_HR_72.webp",
    about: "https://customer-assets-jai6qajn.emergentagent.net/job_fama-roma-pm/artifacts/d848d3kx_viadeicampani72_HR_45.webp",
    aboutSecondary:
        "https://customer-assets-jai6qajn.emergentagent.net/job_fama-roma-pm/artifacts/ovvavmtd_viagiovanniseverano32_HR_65.webp",
    famaLab:
        "https://customer-assets-jai6qajn.emergentagent.net/job_fama-roma-pm/artifacts/sjhs3i6d_viagiovanniseverano32_HR_25.webp",
    ctaBackground:
        "https://customer-assets-jai6qajn.emergentagent.net/job_fama-roma-pm/artifacts/4l7kcshw_viadeicampani72_HR_28.webp",
};
